import { NgModule } from '@angular/core';
import { NewsroomModule } from './Newsroom/newsroom.module';
import { NewswireModule } from './Newswire/newswire.module';
import { NewsroomComponent } from './Newsroom/components/Newsroom/newsroom.component';
import { NewswireComponent } from './Newswire/components/newswire/newswire.component';

@NgModule({
    imports: [
        NewsroomModule,
        NewswireModule
    ],
    exports: [
        NewsroomComponent,
        NewswireComponent
    ]
})
export class NewsModule {
}
